import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CmsserviceService } from 'src/app/common-cms-service/cmsservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-year-ten-mocktest',
    templateUrl: './year-ten-mocktest.component.html',
    styleUrls: ['./year-ten-mocktest.component.css'],
    standalone: false
})
export class YearTenMocktestComponent implements OnInit {

   title = 'GCSE Mock Test Calendar';
    filters: any = { categoryId: null, pattern: null, mode: null, month: null, center: null, search: '' };
  
    months = [
      { label: 'January', value: 1 }, { label: 'February', value: 2 }, { label: 'March', value: 3 },
      { label: 'April', value: 4 }, { label: 'May', value: 5 }, { label: 'June', value: 6 },
      { label: 'July', value: 7 }, { label: 'August', value: 8 }, { label: 'September', value: 9 },
      { label: 'October', value: 10 }, { label: 'November', value: 11 }, { label: 'December', value: 12 }
    ];
  
    categories: any[] = [];
    gcseCategories: any[] = [];
    patterns: string[] = ['AQA', 'OCR', 'Edexcel'];
    centers: string[] = [];
  
    allTests: any[] = [];
    testList: any[] = [];
    private ngUnsubscribe = new Subject<void>();
  
    private preselectCategoryId: number | null = null;
    private shouldAutoScroll = false;
  
    constructor(
      private router: ActivatedRoute,
      private titleService: Title,
      private categoryProduct: CmsserviceService,
      private route: Router,
      private ref: ChangeDetectorRef
    ) {}
  
    ngOnInit() {
      this.titleService.setTitle(this.title);
      this.fetchTests();
      
  
      // read query params for preselection & scroll
      this.router.queryParams.subscribe(params => {
        if (params['category']) {
          const cid = Number(params['category']);
          if (!isNaN(cid)) {
            this.preselectCategoryId = cid;   // remember to apply AFTER data load
            this.filters.categoryId = cid;    // set immediately so UI shows selected
          }
        }
        if (params['scroll'] === 'calendar-section') {
          this.shouldAutoScroll = true;
        }
      });
  
      this.autoScorll();
    }
  
    ngOnDestroy() {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  
    
  
    // -------------------- Fetch everything --------------------
    fetchTests() {
  $('.loader-bg').fadeIn();
  var self = this;

  this.categoryProduct.getTestFilters()
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(function (res: any) {

      self.categories = res && res.data && res.data.category ? res.data.category : [];
      self.gcseCategories = self.extractGcseCategories(self.categories);

      // ✅ AUTO-SELECT DEFAULT CATEGORY (Angular 7 safe)
      self.filters.categoryId = "Y10 GCSE Mock Test";

      // Build category ID array
      var catIds = [];
      for (var i = 0; i < self.gcseCategories.length; i++) {
        catIds.push(String(self.gcseCategories[i].category_id));
      }

      var formData = {
        release: 'new',
        page: 1,
        user_id: +localStorage.getItem('userid') || 0,
        course: [],
        category: catIds,
        type: [],
        search: self.filters.search || '',
        exam_type: self.mapExamType(self.filters.mode)
      };

      self.allTests = [];
      self.fetchPage(formData);

    }, function () {
      $('.loader-bg').fadeOut();
    });
}
  
    private fetchPage(formData: any) {
      var self = this;
      this.categoryProduct.getTestList(formData)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(function(res: any) {
          var chunk = (res && res.data) ? res.data : [];
          var extra = (res && res.extra && res.extra.extraCount) ? res.extra.extraCount : 0;
  
          for (var i = 0; i < chunk.length; i++) self.allTests.push(chunk[i]);
  
          if (extra > 0) {
            formData.page = formData.page + 1;
            self.fetchPage(formData);
            return;
          }
  
          $('.loader-bg').fadeOut();
          self.centers = self.buildCenters(self.allTests);
          self.testList = self.applyLocalFilters(self.allTests);
          self.ref.detectChanges();
        }, function() { $('.loader-bg').fadeOut(); });
  
    }
  
    // -------------------- Local filtering --------------------
    private applyLocalFilters(source: any[]): any[] {
    var list = source.slice(0);
  
    // CATEGORY FILTER – works with string-based category
    if (this.filters.categoryId) {
      var selectedCategory = (this.filters.categoryId + '').toLowerCase().trim();
      var tmpCat: any[] = [];
      for (var i = 0; i < list.length; i++) {
        var cat = '';
        if (list[i].category) cat = (list[i].category + '').toLowerCase().trim();
        else if (list[i].category_name) cat = (list[i].category_name + '').toLowerCase().trim();
        if (cat.indexOf(selectedCategory) !== -1) tmpCat.push(list[i]);
      }
      list = tmpCat;
    }
  
    // PATTERN FILTER
    if (this.filters.pattern) {
      var p = (this.filters.pattern + '').toLowerCase();
      var tmp2: any[] = [];
      for (var j = 0; j < list.length; j++) {
        var nm = ((list[j].test_name || '') + '').toLowerCase();
        if (nm.indexOf(p) !== -1) tmp2.push(list[j]);
      }
      list = tmp2;
    }
  
    // MODE FILTER
    if (this.filters.mode && this.filters.mode !== 'Both') {
      var mode = (this.filters.mode + '').toLowerCase();
      var tmp3: any[] = [];
      for (var k = 0; k < list.length; k++) {
        var et = ((list[k].exam_type || '') + '').toLowerCase();
        if (mode.indexOf('online') !== -1 && et.indexOf('online') !== -1) tmp3.push(list[k]);
        else if ((mode.indexOf('face') !== -1 || mode.indexOf('classroom') !== -1) && et.indexOf('classroom') !== -1) tmp3.push(list[k]);
      }
      list = tmp3;
    }
  
    // MONTH FILTER – supports ranges like "02/11/2025 - 30/08/2026"
    if (this.filters.month) {
      var m = this.filters.month;
      var tmp4: any[] = [];
      for (var a = 0; a < list.length; a++) {
        var dateStr = (list[a].test_date || '').trim();
        if (dateStr.indexOf('-') !== -1) {
          var parts = dateStr.split('-');
          var start = this.parseDate(parts[0]);
          var end = this.parseDate(parts[1]);
          if (start && end) {
            if ((start.getMonth() + 1) === m || (end.getMonth() + 1) === m) tmp4.push(list[a]);
          }
        } else {
          var d = this.parseDate(dateStr);
          if (d && (d.getMonth() + 1) === m) tmp4.push(list[a]);
        }
      }
      list = tmp4;
    }
  
    // CENTER FILTER
    if (this.filters.center) {
      var c = (this.filters.center + '').toLowerCase();
      var tmp5: any[] = [];
      for (var b = 0; b < list.length; b++) {
        var loc = ((list[b].location || '') + '').toLowerCase();
        var al = ((list[b].all_location || '') + '').toLowerCase();
        if (loc.indexOf(c) !== -1 || al.indexOf(c) !== -1) tmp5.push(list[b]);
      }
      list = tmp5;
    }
  
    // SEARCH FILTER
    if (this.filters.search && this.filters.search.replace(/\s+/g, '') !== '') {
      var s = (this.filters.search + '').toLowerCase();
      var tmp6: any[] = [];
      for (var z = 0; z < list.length; z++) {
        var blob = JSON.stringify(list[z]).toLowerCase();
        if (blob.indexOf(s) !== -1) tmp6.push(list[z]);
      }
      list = tmp6;
    }
  
    // SORT ASCENDING BY START DATE
    list.sort((a: any, b: any) => {
      var da = this.extractFirstDate(a.test_date);
      var db = this.extractFirstDate(b.test_date);
      if (!da && !db) return 0;
      if (!da) return 1;
      if (!db) return -1;
      return da.getTime() - db.getTime();
    });
  
    return list;
  }
  
  // --- helper functions below ---
  
  private parseDate(dateStr: string): Date | null {
    var clean = dateStr.replace(/\s+/g, '').replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
    var d = new Date(clean);
    return isNaN(d.getTime()) ? null : d;
  }
  
  private extractFirstDate(range: string): Date | null {
    if (!range) return null;
    var part = range.split('-')[0].trim();
    return this.parseDate(part);
  }
  
    // -------------------- Category matching helpers --------------------
    private getSelectedCategory(sel: any): { id: string | null, name: string } {
      if (sel == null) return { id: null, name: '' };
  
      if (typeof sel === 'object') {
        var sid = null;
        if (sel.category_id != null) sid = String(sel.category_id);
        else if (sel.id != null) sid = String(sel.id);
        var sname = '';
        if (sel.category_name) sname = String(sel.category_name).toLowerCase();
        else if (sel.name) sname = String(sel.name).toLowerCase();
        return { id: sid, name: sname };
      }
  
      var s = String(sel);
      var n = Number(s);
      if (!isNaN(n) && s === String(n)) return { id: s, name: '' };
      return { id: null, name: s.toLowerCase() };
    }
  
    private matchesCategory(test: any, want: { id: string | null, name: string }): boolean {
      if (!want.id && !want.name) return true;
  
      var tid = null;
      if (test && test.category_id != null) tid = String(test.category_id);
      else if (test && test.category && test.category.category_id != null) tid = String(test.category.category_id);
  
      var tname = '';
      if (test && test.category && test.category.category_name) tname = String(test.category.category_name).toLowerCase();
      else if (test && test.category_name) tname = String(test.category_name).toLowerCase();
      else if (test && typeof test.category === 'string') tname = String(test.category).toLowerCase();
  
      if (want.id && tid && tid === want.id) return true;
      if (want.name && tname.indexOf(want.name) !== -1) return true;
      return false;
    }
  
    // -------------------- UI actions --------------------
    applyFilters() {
      this.testList = this.applyLocalFilters(this.allTests);
      this.ref.detectChanges();
    }
  
    resetFilters() {
      this.filters = { categoryId: null, pattern: null, mode: null, month: null, center: null, search: '' };
      this.applyFilters();
    }
  
    // -------------------- Helpers --------------------
    private extractGcseCategories(all: any[]): any[] {
      var out: any[] = [];
      for (var i = 0; i < (all || []).length; i++) {
        var nm = ((all[i].category_name || '') + '').toLowerCase();
        if (nm.indexOf('gcse') !== -1) out.push(all[i]);
      }
      return out;
    }
  
    private mapExamType(mode: any): string {
      var m = (mode || '').toLowerCase();
      if (m.indexOf('online') !== -1) return 'online';
      if (m.indexOf('face') !== -1 || m.indexOf('classroom') !== -1) return 'classroom';
      return 'both';
    }
  
    private buildCenters(list: any[]): string[] {
      var set: any = {};
      for (var i = 0; i < (list || []).length; i++) {
        var v = ((list[i].all_location || list[i].location || '') + '').trim();
        if (v) set[v] = true;
      }
      var out: string[] = [];
      for (var k in set) if (set.hasOwnProperty(k)) out.push(k);
      out.sort();
      return out;
    }
  
    trimChar(str: string, length: number = 30) {
      if (!str) return '';
      return str.length < length ? str : str.substring(0, length) + '...';
    }
  
    getPatternFromName(name: string): string {
      var n = (name || '').toLowerCase();
      if (n.indexOf('aqa') !== -1) return 'AQA';
      if (n.indexOf('ocr') !== -1) return 'OCR';
      if (n.indexOf('edexcel') !== -1) return 'Edexcel';
      return 'GCSE';
    }
  
    getPatternClass(name: string): string {
      var p = this.getPatternFromName(name);
      if (p === 'AQA') return 'badge-pattern badge-aqa';
      if (p === 'OCR') return 'badge-pattern badge-ocr';
      if (p === 'Edexcel') return 'badge-pattern badge-edexcel';
      return 'badge-pattern';
    }
  
    autoScorll(){
      if (this.shouldAutoScroll) {
          // delay slightly so DOM updates and change detection happen
          setTimeout(() => {
            this.scrollToCalendar();
          }, 200);
        }
    }
  
    scrollToCalendar() {
      const offerElement = document.getElementById("calendar-section");
      if (offerElement) {
        offerElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  
  
     downloadCalendar() {
      window.location.href = "https://drive.google.com/uc?export=download&id=1j0hsz0x9nW8QObcBcIxxFn2IP378eQR7";
    }

}
